<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500px"
    scrollable
    @keydown.esc="dialog = false"
  >
    <card :loading="loading" :disabled="loading">
      <card-title large closeable @click:close="dialog = false">
        {{ formTitle }}
      </card-title>
      <card-content>
        <validation-observer ref="validator">
          <user-form
            v-model="userData"
            :roles="roles"
            :action="formAction"
            :readonly="readonly"
          />
        </validation-observer>
      </card-content>
      <card-actions>
        <v-spacer />
        <v-btn
          id="form-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="dialog = false"
        >
          {{ readonly ? "Закрыть" : "Отменить" }}
        </v-btn>
        <v-btn
          v-if="!readonly"
          id="form-btn-save"
          color="primary"
          depressed
          @click="saveUser"
        >
          Сохранить
        </v-btn>
      </card-actions>
    </card>
  </v-dialog>
</template>
<script>
import NotificationMixin from "@/mixins/NotificationMixin";
import Repository from "@/api/users";
import UserForm from "./UserForm.vue";

const userFactory = () => ({
  name: "",
  password: "",
  email: "",
  add_info: "",
  change_password: false,
  roles: [],
  visible_password: false,
  visible_confirmation: false
});

export default {
  components: { UserForm },

  mixins: [NotificationMixin],

  model: {
    prop: "open",
    event: "change"
  },

  props: {
    open: Boolean,
    userId: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      required: true
    },
    roles: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      loading: false,
      userData: userFactory()
    };
  },

  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    },
    formAction() {
      const modTitle = this.userId ? "edit" : "create";
      return this.readonly ? "view" : modTitle;
    },
    formTitle() {
      return this.formAction == "edit"
        ? "Редактирование пользователя"
        : "Создание пользователя";
    }
  },

  watch: {
    open(newVal) {
      if (newVal && this.userId) {
        this.loadUser();
      } else if (!newVal) {
        this.resetForm();
        this.$emit("close");
      }
    }
  },

  methods: {
    async saveUser() {
      try {
        if (!(await this.$refs.validator.validate())) return;
        const { userData, userId } = this;
        const payload = { ...userData };

        this.loading = true;

        const { data } = userId
          ? await Repository.update(userId, payload)
          : await Repository.create(payload);

        this.$emit("apply");
        this.sendAlert(data.alert);

        if (this.$store.getters.getMyId === userId) {
          this.$store.dispatch("fetchProfile");
        }
        this.dialog = false;
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },
    async loadUser() {
      try {
        const { userId, userData } = this;
        this.loading = true;
        const { data } = await Repository.getOne(userId);
        this.userData = { ...userData, ...data };
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.userData = userFactory();
      if (this.$refs.validator) this.$refs.validator.reset();
    }
  }
};
</script>
